import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";

import { Box, Grid, Stack, Skeleton, CardMedia, Typography } from "@mui/material";

// Components
import { userState, scrapInfoType } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useWindowSize } from "../../utils/useWindowSize";
import Navigation from "./component/Navigation";
import CardBtnScrap from "./component/CardBtnScrap";
import PopScrapDetail from "./PopScrapDetail";

// CSS
import "./ScrapList.css";
import "swiper/css";
import PopScrapDetail2 from "./PopScrapDetail2";

interface propsType {
  userState: userState;
}

const unAuthAPI = new HttpUnAuthApi();

const ScrapList = (props: propsType) => {
  const windowSize = useWindowSize();
  const popScrapDetailRef: any = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("recent");
  const [scrapList, setScrapList] = useState<scrapInfoType[]>([]);
  const [selectedScrapInfo, setSelectedScrapInfo] = useState<any>(null);

  useEffect(() => {
    if (!props.userState.isAuth) window.location.href = "/";
    return () => {
      setIsLoading(false);
      setSelectedPeriod("recent");
      setScrapList([]);
      setSelectedScrapInfo(null);
    };
  }, []);

  const get_scrap_list = async () => {
    const param: any = {
      command: "get_scrap_list",
      user_id: props.userState.id,
      sort: "DESCEND",
    };

    const search_dtm = _make_search_dtm();
    param.from_dtm = search_dtm.from;
    param.to_dtm = search_dtm.to;

    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setSelectedScrapInfo(null);
      setScrapList(res.response.scrap_list);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    get_scrap_list();
  }, [selectedPeriod]);

  //--------------------------------------------------
  // Sub module functions
  //--------------------------------------------------
  // 검색 조건별 날짜 계산
  const _make_search_dtm = () => {
    let from_dtm = "";
    let to_dtm = "";
    // 검색 조건별 날짜 세팅
    if (selectedPeriod === "recent") {
      // 3일전
      from_dtm = dayjs().subtract(3, "day").format("YYYYMMDD");
      to_dtm = dayjs().add(1, "day").format("YYYYMMDD");
    } else if (selectedPeriod === "week") {
      // 1주일
      from_dtm = dayjs().subtract(7, "day").format("YYYYMMDD");
      to_dtm = dayjs().add(1, "day").format("YYYYMMDD");
    } else if (selectedPeriod === "month") {
      // 1주일
      from_dtm = dayjs().subtract(1, "month").format("YYYYMMDD");
      to_dtm = dayjs().add(1, "day").format("YYYYMMDD");
    } else if (selectedPeriod === "quarter") {
      // 6개월
      from_dtm = dayjs().subtract(6, "month").format("YYYYMMDD");
      to_dtm = dayjs().add(1, "day").format("YYYYMMDD");
    }
    return { from: from_dtm, to: to_dtm };
  };

  return (
    <>
      <section id="commWrap" className="scrap-list">
        <article className="article-01">
          <div className="article-tit ta-c">
            {"스크랩한 Brief들로"}
            <br />
            <span className="highlighter">{"나만의 리포트"}</span>
            {"를 발행해보세요"}
          </div>
        </article>
        <Navigation
          userState={props.userState}
          selectedPeriod={selectedPeriod}
          callback={(payload: any) => {
            if (payload.command === "selected_period") {
              setSelectedPeriod(payload.value);
            } else if (payload.command === "finish_create_new_scrap") {
              get_scrap_list();
            }
          }}
        />
        <Box
          sx={{
            pb: "115px",
          }}
        >
          <Stack direction={"column"} spacing={0}>
            <Grid container spacing={3}>
              {isLoading && scrapList.length < 1
                ? [...Array(2)].map((value: any, index) => (
                    <Grid key={`scrap-${index}`} item xs={12} md={12} lg={6} xl={6}>
                      <Skeleton
                        key={`scrap-${index}`}
                        variant="rounded"
                        width={"100%"}
                        height={windowSize.width > 1023 ? "153px" : "123px"}
                        sx={{ borderRadius: "30px" }}
                      />
                    </Grid>
                  ))
                : scrapList.map((scrapInfo: any, index: number) => (
                    <Grid key={`scrap-${index}`} item xs={12} md={12} lg={6} xl={6}>
                      <CardBtnScrap
                        userState={props.userState}
                        scrapInfo={scrapInfo}
                        selectedScrapInfo={selectedScrapInfo}
                        callback={(payload: any) => {
                          if (payload.command === "select_scrap_info") {
                            popScrapDetailRef.current.open(payload.value);
                            setSelectedScrapInfo(payload.value);
                          } else if (payload.command === "finish_delete_scrap_info") {
                            get_scrap_list();
                          } else if (payload.command === "update_title") {
                            get_scrap_list();
                          }
                        }}
                      />
                    </Grid>
                  ))}
            </Grid>
            {!isLoading && scrapList.length < 1 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                  p: "100px 0px",
                }}
              >
                <Box>
                  <CardMedia component={"img"} image="/images/img-empty.png" sx={{ width: "102px", height: "85px" }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "500", lineHeight: "1.3", color: "rgba(138, 138, 138, 1)" }}>
                    {"생성된 스크랩 보드가 없습니다."}
                  </Typography>
                </Box>
              </Box>
            )}
          </Stack>
        </Box>
      </section>
      <PopScrapDetail2
        ref={popScrapDetailRef}
        userState={props.userState}
        callback={(payload: any) => {
          if (payload.command === "close") {
            get_scrap_list();
          }
        }}
      />
    </>
  );
};

export default ScrapList;
